import { render, staticRenderFns } from "./signType.vue?vue&type=template&id=54492001&scoped=true"
import script from "./signType.vue?vue&type=script&lang=js"
export * from "./signType.vue?vue&type=script&lang=js"
import style0 from "./signType.vue?vue&type=style&index=0&id=54492001&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54492001",
  null
  
)

export default component.exports